/* ================================================================
   LF BUTTON POP — Design Checkpoint 1 (B6)
   REVISEMENT — the multicolor glow-pop this file used to wire up is
   retired entirely ("the glow effect... I don't want it" / "nothing
   should... glow colors it looks ugly"). File kept (rather than
   deleted) only because other assets may still reference
   window.__lfBtnsBound as an init-guard check; it now does nothing.
   Menu tile tap feedback lives in templates/index.liquid's own
   .is-selecting script + lfj-pixel.css's dissolve keyframes instead.
================================================================ */
(function () {
  'use strict';
  if (window.__lfBtnsBound) return;
  window.__lfBtnsBound = true;
  // Intentionally no-op. See header comment.
}());
